var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.075 14.1625C23.9063 13.3323 24.5404 12.3259 24.9302 11.2177C25.3201 10.1095 25.4559 8.92776 25.3274 7.75999C25.199 6.59221 24.8097 5.46825 24.1883 4.47123C23.5669 3.47421 22.7294 2.62963 21.7375 1.99997C19.225 0.337473 15.8625 0.324973 13.325 1.96247C11.125 3.37497 9.91254 5.57497 9.70004 7.84997C9.53754 9.49997 8.91254 11.0375 7.76254 12.1875L7.72504 12.225C6.27504 13.675 6.27504 15.8875 7.63754 17.2375L8.87504 18.475C9.52994 19.1294 10.4179 19.4971 11.3438 19.4971C12.2697 19.4971 13.1576 19.1294 13.8125 18.475C15.025 17.2625 16.625 16.6 18.3625 16.4125C20.075 16.225 21.75 15.475 23.075 14.1625ZM5.70004 23.075C6.03754 23.775 5.92504 24.625 5.33754 25.2C5.0831 25.4583 4.7588 25.6367 4.40443 25.7133C4.05006 25.7899 3.68102 25.7615 3.34259 25.6314C3.00416 25.5014 2.71105 25.2753 2.49921 24.9811C2.28737 24.6869 2.16602 24.3372 2.15004 23.975C1.78783 23.959 1.43816 23.8376 1.14392 23.6258C0.849676 23.414 0.623661 23.1209 0.493598 22.7824C0.363534 22.444 0.335076 22.075 0.411715 21.7206C0.488354 21.3662 0.666757 21.0419 0.92504 20.7875C1.50004 20.2125 2.36254 20.0875 3.05004 20.425L6.15004 17.3875C6.32504 17.625 6.52504 17.9 6.75004 18.125L7.98754 19.3625C8.25004 19.6125 8.50004 19.825 8.82504 20.0125L5.70004 23.075Z",
    fill: "url(#paint0_linear_344_665)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_344_665",
    x1: 12.872,
    y1: 0.743652,
    x2: 12.872,
    y2: 25.7554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D0000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeat);
export default __webpack_public_path__ + "static/media/meat.4e3bfdc21c3d394a06088d64751f8258.svg";
export { ForwardRef as ReactComponent };